import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';
import { NumberFormatterService } from '../../../../../../../core/services/number.formatter.service';
import { DialogsService } from '../../../../../../../core/services/dialog.service';
import * as copy from 'copy-to-clipboard';
import { AppMessagingService } from '../../../../../../../core/services/app-messaging.service';
import { VesselDAO } from '../../../../../../../core/services/dao/vesselDAO';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ContainsSubscriptions } from '../../../../../../../core/services/interfaces/contains-subscriptions';
import { unsubscribeFromAll } from '../../../../../../../core/pure-functions/rx-helper';
import { Subscription } from 'rxjs/Rx';
import { Category } from 'anchor-shared/lib/model/enum/vessel-category-types';
import { CategoryType2LabelMapping } from 'anchor-shared/lib/service/pure-functions/vessel-helper/CategoryType2LabelMapping';

@Component({
  selector: 'app-boat-information-form',
  templateUrl: './boat-information.component.html',
  styleUrls: ['./boat-information.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class BoatInformationFormComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  @Input() vessel: Vessel;

  @Input() canSave: boolean;

  @Input() isAdmin: boolean;

  public CategoryType2LabelMapping = CategoryType2LabelMapping;

  public CategoryTypes = Object.values(Category);
  subs: Subscription[] = [];
  modelSaving = false;
  vesselInfo: Partial<Vessel>;

  constructor(
    public dialog: DialogsService,
    private appMessagingService: AppMessagingService,
    private vesselDAO: VesselDAO,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit() {
    this.vessel.numOfCabins = this.vessel.numOfCabins ?? 0;
    this.vessel.numOfBathrooms = this.vessel.numOfBathrooms ?? 0;
    this.vessel.numOfShowers = this.vessel.numOfShowers ?? 0;
    this.vessel.sleepsNum = this.vessel.sleepsNum ?? 0;
    this.setVesselInfo();
  }

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  copyTo(val: string): void {
    const success = copy(val);
    if (success) {
      this.appMessagingService.openSnack('Copied To Clipboard');
    }
  }

  setVesselInfo() {
    this.vesselInfo = {
      id: this.vessel.id,
      name: this.vessel.name,
      yearBuilt: this.vessel.yearBuilt,
      make: this.vessel.make,
      model: this.vessel.model,
      numOfPassengers: this.vessel.numOfPassengers,
      category: this.vessel.category,
      lengthFt: this.vessel.lengthFt,
      numOfCabins: this.vessel.numOfCabins,
      sleepsNum: this.vessel.sleepsNum,
      numOfBathrooms: this.vessel.numOfBathrooms,
      numOfShowers: this.vessel.numOfShowers,
      featured: this.vessel.featured,
    } as Partial<Vessel>;
  }

  openSnackbar(message: string) {
    this.snackBar.open(message, null, {
      duration: 5000,
      verticalPosition: 'top',
    });
  }
}
